import { camelizeKeys, pascalizeKeys } from 'humps';
export function downloadFile(downloadUrl, types, params, method = 'GET', customHeaders = {}) {
  return (dispatch, getState) => {
    const { app: { application: { headers } } } = getState();
    const fetchOptions = {
      mode: 'cors',
      method,
      credentials: 'include',
      headers: Object.assign({}, headers, customHeaders),
    };
    fetchOptions.headers['Content-Type'] = 'application/json';
    if (typeof(params) !== 'undefined') {
      fetchOptions.body = JSON.stringify(pascalizeKeys(params));
    }
    dispatch({ type: types[0] });
    return fetch(downloadUrl, fetchOptions).then(response => {
      if (response.ok) {
        return Promise.resolve(response);
      }
      return response.json().then(json => {
        return Promise.reject({ json, response });
      });
    }).then((response) => {
      dispatch({ type: types[1] });
      return response.blob();
    }, ({ json, response }) => {
      const camelizedJson = camelizeKeys(json);
      let error = null;
      if (typeof(camelizedJson.error) !== 'undefined') {
        error = {
          'status': camelizedJson.error.status,
          'message': camelizedJson.error.detail,
        };
      } else {
        error = {
          'status': response.status,
          'message': response.statusText,
        };
      }
      dispatch({ type: types[2],
        error,
      });
      return Promise.reject(error);
    });
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/utils/downloadFile.js
 **/